export const COMPLETENESS_STATUSES = [
  'MISSING',
  'PARTIAL',
  'COMPLETE',
] as const;
export type CompletenessStatus = (typeof COMPLETENESS_STATUSES)[number];

export const NETWORKS = ['DACH', 'FR_BE', 'US'] as const;
export type Network = (typeof NETWORKS)[number];

export type NetworkFilter = Network | 'UNKNOWN';

export const SORT_KEYS = ['PHOTOS', 'HOURS', 'DESCRIPTION'] as const;
export type SortKey = (typeof SORT_KEYS)[number];

export type CompletenessCategory = 'photos' | 'description' | 'openingHours';
export type CompletenessStatusKey = `${CompletenessCategory}Status`;

export interface CategoryMeta {
  readonly key: CompletenessCategory;
  readonly statusKey: CompletenessStatusKey;
  readonly label: string;
  readonly sort: SortKey;
}

export const COMPLETENESS_CATEGORIES = [
  { key: 'photos', statusKey: 'photosStatus', label: 'Photos', sort: 'PHOTOS' },
  {
    key: 'openingHours',
    statusKey: 'openingHoursStatus',
    label: 'Hours',
    sort: 'HOURS',
  },
  {
    key: 'description',
    statusKey: 'descriptionStatus',
    label: 'Description',
    sort: 'DESCRIPTION',
  },
] as const satisfies readonly CategoryMeta[];

export interface NetworkFilterOption {
  readonly value: NetworkFilter;
  readonly display: string;
}

export const NETWORK_FILTER_OPTIONS = [
  { value: 'DACH', display: 'DACH' },
  { value: 'FR_BE', display: 'FR&BE' },
  { value: 'US', display: 'US' },
  { value: 'UNKNOWN', display: 'Not set' },
] as const satisfies readonly NetworkFilterOption[];

export interface StatusDisplay {
  readonly label: string;
  readonly styleClass: string;
}

export const STATUS_DISPLAY: Readonly<
  Record<CompletenessStatus, StatusDisplay>
> = {
  MISSING: { label: 'Missing', styleClass: 'status-missing' },
  PARTIAL: { label: 'Partial', styleClass: 'status-partial' },
  COMPLETE: { label: 'Complete', styleClass: 'status-complete' },
};

export type GymProfileCompleteness = Record<
  CompletenessStatusKey,
  CompletenessStatus
> & {
  gymId: string;
  egymLegacyGymId: number;
  egymLegacyGymChainId: string | null;
  gymUUID: string | null;
  gymName: string | null;
  network: Network | null;
};

export type ProfileCompletenessSummary = Record<
  CompletenessCategory,
  number
> & {
  total: number;
};

export interface Page<T> {
  items: T[];
  pageIndex: number;
  pageSize: number;
  total: number;
}

export interface ProfileCompletenessRequest {
  networkFilter?: readonly NetworkFilter[];
  sorting: SortKey;
  searchTerm?: string;
  page: number;
  pageSize: number;
}

export interface ProfileCompletenessExportRequest {
  networkFilter?: readonly NetworkFilter[];
  sorting?: SortKey;
  searchTerm?: string;
}
